import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  CalendarEvent,
  eventsKey,
  getEnterpriseCalendarEventsRoute,
  InterviewBlock,
} from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseEventsData = {
  total_pages: any;
  current_page: any;
  blocks: any;
  status: number;
  message: string;
  object: InterviewBlock[];
};

type useGetEnterpriseEventsProps = {
  dateInfo:{ month: string, year: string },
  selectedCompanyId: string | number,
  setEvents: Dispatch<SetStateAction<any>>;
};

export const useGetEnterpriseEvents = ({
  dateInfo,
  setEvents,
  selectedCompanyId,
}: useGetEnterpriseEventsProps) => {

  const { isLoading: isLoadingBlocks } =  useQuery<useGetEnterpriseEventsData>({
    queryKey: [eventsKey, selectedCompanyId,dateInfo],
    queryFn: () => {
      const params = new URLSearchParams();
    
      if (selectedCompanyId) {
        params.append('company_id', String(selectedCompanyId));
      }
      if (dateInfo) {
        params.append('year', String(dateInfo.year));
        params.append('month', String(dateInfo.month));
      }

      return axiosInstance
        .get(getEnterpriseCalendarEventsRoute, { params })
        .then((res) => res.data);
    },
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data.status === 200) {
        const formattedBlocks: CalendarEvent[] =
          data?.blocks?.map((block: InterviewBlock) => ({
            start: block.dt_start_time,
            end: block.dt_end_time,
            title: (block?.slots?.length ?? 0) > 0 ? 'Interview Block' : 'Open Interviews',
            event: block,
            id: block.id
          })) ?? [];
          setEvents([...formattedBlocks]);
      } else  {
        setEvents([])
      } 
    },
  });
  return { isLoadingBlocks };
};
